import { createReducer, on } from "@ngrx/store";
import { StandingAuthorizationsTableActions } from "../../create-request/actions";

export const submitDeleteFeatureKey = 'submitDelete';

interface DeletedState {
  isCancelTransactionCallFinished: boolean;
  isCancelTransactionSubmitted: boolean;
  hasCancelTransactionError: boolean;
  hasPendingTransactions: boolean;
  cancelledTransactionId: string;
  isNewAchProfile: boolean;
}

export interface State extends DeletedState { }

export const initialSubmitDeleteStandingAuthState: State = {
  isCancelTransactionCallFinished: false,
  isCancelTransactionSubmitted: false,
  hasCancelTransactionError: false,
  hasPendingTransactions: false,
  cancelledTransactionId: '',
  isNewAchProfile: false
}

export const submitDeleteStandingAuthReducer = createReducer(
  initialSubmitDeleteStandingAuthState,
  on(StandingAuthorizationsTableActions.deleteTransactionSuccess, (state, response) => {
    return {
      ...state,
      isCancelTransactionCallFinished: true,
      isCancelTransactionSubmitted: true,
      hasCancelTransactionError: false,
      hasPendingTransactions: false,
      isNewAchProfile: response.isNewAchProfile
    }
  }),
  on(StandingAuthorizationsTableActions.deleteTransactionFailure, (state) => {
    return {
      ...state,
      isCancelTransactionCallFinished: true,
      isCancelTransactionSubmitted: false,
      hasCancelTransactionError: true,
      hasPendingTransactions: false,
      cancelledTransactionId: ''
    }
  }),
  on(StandingAuthorizationsTableActions.resetSubmitCancelTransactionState, (state) => {
    return {
      ...state,
      isCancelTransactionCallFinished: false,
      isCancelTransactionSubmitted: false,
      hasCancelTransactionError: false,
      hasPendingTransactions: false
    }
  }),
  on(StandingAuthorizationsTableActions.deleteTransactionFailurePendingTransaction, (state) => {
    return {
      ...state,
      isCancelTransactionCallFinished: true,
      isCancelTransactionSubmitted: false,
      hasCancelTransactionError: true,
      hasPendingTransactions: true
    }
  })
)